export const SENTRY_ORG = 'ramp106'

const PRODUCTION_LIKE_ENVIRONMENTS: readonly string[] = ['production', 'staging']

export const DEFAULT_TRACES_SAMPLE_RATE = 0.1
export const DEFAULT_REPLAYS_SESSION_SAMPLE_RATE = 0.1
export const DEFAULT_REPLAYS_ON_ERROR_SAMPLE_RATE = 1.0
export const DEFAULT_PROFILES_SAMPLE_RATE = 1.0

/**
 * Hosts that receive the `sentry-trace` / `baggage` headers, so a browser trace
 * continues into the backend that serves the request instead of the two showing
 * up as unrelated traces.
 *
 * Scoped to OMR backends on purpose: propagating to third parties leaks trace
 * ids and can trip their CORS preflights. myomr allows these same headers for
 * the same origins in its own CORS config.
 *
 * The host class allows dots: these apps call `api.jobs.omr.com` and
 * `api.reviews.omr.com`, so matching a single label before `omr` would silently
 * skip the Jobs and Reviews APIs. A repeated group `([a-z0-9-]+\.)+` would read
 * more precisely but trips eslint's security/detect-unsafe-regex. The trailing
 * anchor is what keeps the match safe, since without it
 * `https://my.omr.com.example/` would qualify too.
 */
export const DEFAULT_TRACE_PROPAGATION_TARGETS: readonly (string | RegExp)[] = [
  /^\//,
  /^https:\/\/[a-z0-9.-]+\.omr\.(com|ninja|io)(\/|$)/,
]

export const COMMON_IGNORE_ERRORS: readonly string[] = [
  'AbortError',
  'NotSupportedError',
  'Load failed',
  'The play method is not allowed by the user agent or the platform in the current context',
]

export const isProductionLike = (environment: string | undefined): boolean => PRODUCTION_LIKE_ENVIRONMENTS.includes(environment ?? '')
